import { createFileRoute, redirect } from "@tanstack/react-router";
import { useEffect } from "react";

import { SettingsContentLayout } from "../components/settings/SettingsShell";
import { recordVisitedOrg, useActiveOrgId, useOrgs } from "../state/orgs";

/**
 * The canonical, tenant-scoped settings tree — `/$org/settings/$section`,
 * Linear-style. The org segment keeps the selected tenant visible (and
 * bookmarkable) while account-level pages simply ignore it.
 */
function OrgSettingsShell() {
  const activeOrgId = useActiveOrgId();
  const { orgs } = useOrgs();

  // Visiting an org's settings makes it the active tenant, so `/` and the
  // legacy `/settings` redirector agree with the URL. Recorded only once the
  // segment resolves against the directory — the raw segment may be a slug.
  useEffect(() => {
    if (activeOrgId && orgs.some((org) => org.id === activeOrgId)) {
      recordVisitedOrg(activeOrgId);
    }
  }, [activeOrgId, orgs]);

  return <SettingsContentLayout />;
}

export const Route = createFileRoute("/$org/settings")({
  beforeLoad: async ({ context, location, params }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }

    if (location.pathname.endsWith("/settings")) {
      throw redirect({
        to: "/$org/settings/$section",
        params: { org: params.org, section: "general" },
        replace: true,
      });
    }
  },
  component: OrgSettingsShell,
});
